"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkedin = void 0;
var linkedin = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "linkedin_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "linkedin"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "linkedin"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M0.798,62.986h14.315V22.368H0.798V62.986z M48.434,21.087c-5.925,0-9.192,1.972-12.953,6.749v-5.469H21.189v40.619\r\n\t\t\t\tH35.48V40.914c0-4.658,2.24-9.214,7.596-9.214s6.673,4.555,6.673,9.103v22.184H64v-23.09C64,23.854,54.361,21.087,48.434,21.087z\r\n\t\t\t\t M7.982,2.013C3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M0.798,62.986h14.315V22.368H0.798V62.986z M48.434,21.087c-5.925,0-9.192,1.972-12.953,6.749v-5.469H21.189v40.619\r\n\t\t\t\tH35.48V40.914c0-4.658,2.24-9.214,7.596-9.214s6.673,4.555,6.673,9.103v22.184H64v-23.09C64,23.854,54.361,21.087,48.434,21.087z\r\n\t\t\t\t M7.982,2.013C3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.linkedin = linkedin;